const LoadingSpinner = () => {
  return (
    <div className="flex items-center 
                    justify-center">
      <div className="relative">

        {/* Outer ring */}
        <div className="w-12 h-12 rounded-full 
                        border-2 border-gray-700">
        </div>

        {/* Spinning ring */}
        <div className="w-12 h-12 rounded-full 
                        border-2 border-transparent 
                        border-t-blue-500 
                        animate-spin absolute 
                        top-0 left-0">
        </div>

      </div>
    </div>
  );
};

export default LoadingSpinner;